/* eslint-disable @typescript-eslint/naming-convention */
/**
 * KEY==Value for equality checks
 */
export enum ExaGrant {
  USER = 'USR',
  ADMIN = 'ADMN',
  TECH = 'TECH',
  USER_ADD = 'USR_ADD',
  ENTERPRISE_DRIVER = 'E_DRIV',
  ENTERPRISE_CONSULTANT = 'E_CONS',
  ENTERPRISE_DISPONENT = 'E_DISP',
  ENTERPRISE_ADMIN = 'E_ADMN',
  RETAILER_USER = 'R_USR',
  RETAILER_ADMIN = 'R_ADMN',
  TRANSLATION_EDITOR = 'TRAN',

  READ_LICENSES = 'R_LIC',
  READ_ENTERPRISE = 'R_ENT',
  WRITE_ENTERPRISE = 'W_ENT',
  READ_MACHINE = 'R_MACH',
  WRITE_MACHINE = 'W_MACH',
  DELETE_MACHINE = 'D_MACH',
  EXPORT_MACHINE = 'E_MACH',
  READ_IMPLEMENT = 'R_IMPL',
  WRITE_IMPLEMENT = 'W_IMPL',
  DELETE_IMPLEMENT = 'D_IMPL',
  EXPORT_IMPLEMENT = 'E_IMPL',
  READ_LOCATION = 'R_LOC',
  WRITE_LOCATION = 'W_LOC',
  DELETE_LOCATION = 'D_LOC',
  EXPORT_LOCATION = 'E_LOC',
  READ_FIELD = 'R_FIE',
  WRITE_FIELD = 'W_FIE',
  DELETE_FIELD = 'D_FIE',
  EXPORT_FIELD = 'E_FIE',
  READ_EMPLOYEE = 'R_EMP',
  WRITE_EMPLOYEE = 'W_EMP',
  DELETE_EMPLOYEE = 'D_EMP',
  //EXPORT_EMPLOYEE = 'E_EMP',
  READ_USER_CUSTOMER = 'R_UCST',
  WRITE_USER_CUSTOMER = 'W_UCST',
  DELETE_USER_CUSTOMER = 'D_UCST',
  //EXPORT_USER_CUSTOMER = 'E_UCST',
  READ_EVENT = 'R_EVT',
  WRITE_EVENT = 'W_EVT',
  DELETE_EVENT = 'D_EVT',
  //EXPORT_EVENT = 'E_EVT',
  WRITE_RAW_DATA = 'W_RDAT',
  READ_JOB = 'R_JOB',
  WRITE_JOB = 'W_JOB',
  DELETE_JOB = 'D_JOB',
  EXPORT_JOB = 'E_JOB',
  READ_TASK = 'R_TASK',
  WRITE_TASK = 'W_TASK',
  DELETE_TASK = 'D_TASK',
  EXPORT_TASK = 'E_TASK',
  READ_ADAPTER_STATE = 'R_ADPTSTAT',
  WRITE_ADAPTER_STATE = 'W_ADPTSTAT',
  READ_ADAPTER = 'R_ADPT',
  WRITE_ADAPTER = 'W_ADPT',
  READ_BEACON = 'R_BEAC',
  WRITE_BEACON = 'W_BEAC',
  READ_BEACON_STATE = 'R_BEACSTAT',
  WRITE_BEACON_STATE = 'W_BEACSTAT',
  READ_ISO_TASKDATA = 'R_ISOTD',
  WRITE_ISO_TASKDATA = 'W_ISOTD',
  DELETE_ISO_TASKDATA = 'D_ISOTD',
  EXPORT_ISO_TASKDATA = 'E_ISOTD',
  READ_DEADLINE = 'R_DEA',
  WRITE_DEADLINE = 'W_DEA',
  DELETE_DEADLINE = 'D_DEA',
  //EXPORT_DEADLINE = 'E_DEA',
  READ_WORKINGTIMES = 'R_WOTI',
  //WRITE_WORKINGTIMES = 'W_WOTI',
  DELETE_WORKINGTIMES = 'D_WOTI',
  //EXPORT_WORKINGTIMES = 'E_WOTI',
  READ_RETAILER_CUSTOMER = 'R_RCUS',
  SUBSCRIBE_TO_MACHINE_STATES = 'PS_MACH',
  READ_MACHINE_PATHS = 'R_MAPA',
  READ_STATS = 'R_STAT',
}
